import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-icon',
  templateUrl: 'icon.component.html',
  standalone: false,
})
export class IconComponent {
  @Input() public icon?: string;
}
